<template>
  <v-dialog v-model="dialog" persistent max-width="420">
    <v-card>
      <v-card-title class="headline">
        <span v-html="params.title" />
      </v-card-title>
      <v-card-text v-html="params.text" />
      <v-card-actions>
        <v-spacer />
        <v-btn :color="params.color || 'error'" @click="submit()" v-if="params.confirmText != '' && params.confirmText != null">
          <v-icon v-if="params.icon" class="mr-2">{{ params.icon }}</v-icon>
          {{ params.confirmText }}
        </v-btn>
        <v-btn color="secondary" outline @click="cancel()" v-html="params.cancelText" v-if="params.cancelText != '' && params.cancelText != null" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialog: false,
        params: {},
        initialParams: {
          title: null,
          text: null,
          confirmText: null,
          cancelText: null,
          color: null,
          icon: null,
        },
        promise: null,
      }
    },
    methods: {
      close() {
        this.dialog = false
      },
      cancel() {
        if (this.promise) this.promise.resolve(false)
        this.close()
      },
      submit() {
        if (this.promise) this.promise.resolve(true)
        this.close()
      },
      confirm(params, force = false) {
        if (force) return true

        this.params = {
          ...this.initialParams,
          ...params,
        }

        this.dialog = true
        let result = new Promise((resolve) => {
          this.promise = {
            resolve,
          }
        })

        return result
      },
    },
  }
</script>